import type { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import styles from "./index.module.scss";

export const LegalPageBody = (
    props: Immutable<{ page: templates.LegalPageTemplate["page"] }>,
): React.JSX.Element => (
    <section className={styles.legalContent}>
        <div className="main-container">
            <div
                className={styles.legalTitle}
                dangerouslySetInnerHTML={{
                    __html: props.page.header.html,
                }}
            />
            <div
                className={styles.mainContent}
                dangerouslySetInnerHTML={{
                    __html: props.page.body.html,
                }}
            />
        </div>
    </section>
);
